import { useCallback, useEffect, useState } from "react";
import { Search } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../../components/ui/input";
import { api, fmt } from "../client";
import { PageHeader, Panel, Pill, TierBadge, Empty } from "../ui";
import UserDrawer from "./UserDrawer";
import ZipReach from "./ZipReach";

export default function Users() {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  const search = useCallback((term) => {
    api(`/staff/users?q=${encodeURIComponent(term)}`).then(setRows).catch((e) => toast.error(e.message));
  }, []);
  useEffect(() => { search(""); }, [search]);
  return (
    <div>
      <PageHeader kicker="Account operations" title="Global user search" />
      <ZipReach />
      <form onSubmit={(e) => { e.preventDefault(); search(q); }} className="relative mb-6 max-w-2xl s-rise">
        <Search size={16} className="absolute left-4 top-1/2 -translate-y-1/2 text-[var(--s-dim)]" />
        <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Email, phone, account ID or display name" className="s-input h-12 pl-11" data-testid="users-search-input" />
      </form>
      <Panel className="divide-y divide-[var(--s-line)]" data-testid="users-results">
        {rows === null ? <p className="p-6 text-sm text-[var(--s-dim)]">Loading…</p> : rows.length === 0 ? <Empty>No accounts match.</Empty> : rows.map((u) => (
          <button key={u.user_id} onClick={() => setOpen(u.user_id)} data-testid={`users-row-${u.user_id}`}
            className="flex w-full flex-wrap items-center gap-x-6 gap-y-1 px-5 py-4 text-left transition-colors hover:bg-white/[0.03]">
            <span className="min-w-[180px] flex-1"><span className="block">{u.display_name || "—"}</span><span className="text-xs text-[var(--s-dim)]">{u.email || u.phone || "no contact"}</span></span>
            <span className="s-mono text-xs text-[var(--s-dim)]">{u.user_id}</span>
            <TierBadge tier={u.tier} />
            {u.banned && <Pill tone="bad">Banned</Pill>}
            {u.is_id_verified && <Pill tone="ok" data-testid={`users-id-verified-${u.user_id}`}>ID Verified</Pill>}
            <span className="s-mono hidden text-xs text-[var(--s-dim)] lg:inline">{fmt(u.created_at)}</span>
          </button>
        ))}
      </Panel>
      <UserDrawer uid={open} onClose={() => setOpen(null)} onChanged={() => search(q)} />
    </div>
  );
}
